import { musicServicesByAppID } from 'fym-shared/src/music-services/allMusicServices';

export interface ServiceBrand {
  /** The service name a person recognises ("Apple Music"), or the raw key when it is unknown. */
  name: string;
  /** The brand hex, or null when the key is unknown; the UI then shows a neutral dot. */
  color: string | null;
}

/**
 * Resolves a pitch-event service key to its display name and brand colour (frames s1, s2). The
 * stored keys are the `MusicAPIIntegrationID` form ("appleMusic"). `musicServicesByAppID` also
 * indexes the `id` and `importerID` forms, so either shape of a key resolves. An unknown key keeps
 * its own text and gets a neutral dot — never a guessed name or colour.
 */
export function serviceBrand(key: string): ServiceBrand {
  const service = musicServicesByAppID[key];
  return { name: service?.name ?? key, color: service?.color.primary ?? null };
}
